module.exports = __webpack_public_path__ + "img/narrow-gap-setup.ad155ef0.png";